import { Component, Input, ElementRef, ViewChild } from '@angular/core';

@Component({
  selector: 'new-tooltip',
  templateUrl: './new-tooltip.component.html',
  styleUrls: ['./new-tooltip.component.scss'],
  host: {
    '(mouseover)': 'onMouseHover()',
    '(mouseleave)': 'hideTooltip()'
  }
})
export class NewTooltipComponent {
  @Input() public content: string | string[];
  @Input() public direction: string = 'top';
  @Input() public isString: boolean = true;
  @ViewChild('tooltip') public tooltipRef: ElementRef;

  public tooltipVisible: boolean = false;
  public tooltipPosition: { top: number; left: number } = { top: 0, left: 0 };

  readonly arrowHeight: number = 8;

  constructor() {}

  private onMouseHover() {
    this.buildTooltip();
  }

  public hideTooltip() {
    this.tooltipVisible = false;
  }

  private buildTooltip() {
    const offsetWrapper = this.tooltipRef.nativeElement.getBoundingClientRect();
    const content = this.tooltipRef.nativeElement.nextElementSibling;

    const options: any = {
      top: offsetWrapper.top,
      left: offsetWrapper.left,
      width: this.tooltipRef.nativeElement.offsetWidth,
      height: this.tooltipRef.nativeElement.offsetHeight,
      tooltipContent: {
        width: content.offsetWidth,
        height: content.offsetHeight
      }
    };

    switch (this.direction) {
      case 'top':
        options.top -= content.offsetHeight + this.arrowHeight;
        options.left =
          options.left - options.tooltipContent.width / 2 + options.width / 2;
        break;
      case 'bottom':
        options.top += options.height + this.arrowHeight;
        options.left =
          options.left - options.tooltipContent.width / 2 + options.width / 2;
        break;
      case 'right':
        options.top -= options.tooltipContent.height / 2 - options.height / 2;
        options.left += options.width + this.arrowHeight;
        break;
      case 'left':
        options.top -= options.tooltipContent.height / 2 - options.height / 2;
        options.left -= options.tooltipContent.width + this.arrowHeight;
        break;

      default:
        break;
    }

    this.showTooltip(options);
  }

  public showTooltip(options: any) {
    this.tooltipPosition = {
      top: options.top,
      left: options.left
    };
    this.tooltipVisible = true;
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/new-tooltip/new-tooltip.component.ts